export const getUserInitialsName = (name: string) => {
  if (!name) return null;
  const [first, last] = name.split(' ');
  const initials = `${first?.length ? first.substring(0, 1) : ''}${last?.length ? last.substring(0, 1) : ''}`;
  return initials.toUpperCase();
};
